module.exports = __webpack_public_path__ + "static/media/downloadBtn.3cfb85b9.png";